<template>
  <div class="cartoonDetail">
        <Navigation></Navigation> 
            <div class="bg"></div>
            <div class="mb_cartoon_bg"></div>
            <img src="../assets/images/back_btn.png" alt="" class="back_btn" @click="goback">
            <img src="../assets/images/cartoon_title.png" alt="" class="cartoon_title">
            <img src="../assets/images/msg_btn.png" alt="" class="msg_btn" @click="goMsg">
            <div class="cartoon_detail">
                <div class="cartoon_box">
                    <ul class="cartoon_ul">
                        <li v-for="(item,index) in cartoons" :key="index" v-show="isActiveIndex===index">
                            <img :src="item.content" alt="">
                        </li>
                    </ul>
                </div>
                <img src="../assets/images/front.png" alt="" class="cartoon_front" @click="cartoonPage('front')" v-show="isActiveIndex>0">
                <img src="../assets/images/back.png" alt="" class="cartoon_back" @click="cartoonPage" v-show="isActiveIndex<cartoons.length-1">
            </div>
            <div class="mask" v-show="isMsg">
            <div class="msg">
                <img src="../assets/images/close_role.png" alt="" class="close_msg" @click="isMsg=false">
                <div class="msg_write">
                    <div class="name">
                        <span>お名前：</span>
                        <input type="text" v-model="username" placeholder="お名前を入力してください">
                        <span class="warn" v-show="isWarnName">お名前を入力してください</span>
                    </div>
                    <div class="comment">
                        <div class="tag">コメント：</div>
                        <textarea name="" id="" cols="30" rows="10" v-model="comments" placeholder="コメントを入力してください"></textarea>
                    </div>
                    <div class="send_btn">
                        <span class="warn" v-show="isWarnContent">コメントを入力してください</span>
                        <img src="../assets/images/send_btn.png" alt=""  @click="addMsg">
                    </div>
                </div>
                <div class="msg_list">
                    <ul>
                        <li v-for="(item,index) in massageList" :key="index">
                            <div class="name">
                                <span>お名前：</span>
                                <span>{{item.name}}</span>
                                <span class="date">{{item.date}}</span>
                                <div class="tag">コメント：</div>
                                <div class="info">{{item.content}}</div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
            
  </div>
</template>

<script>
import api from '@/api'
import E from 'wangeditor'
import getQueryString from '@/methods/getQueryString'
import getNowTime from '@/methods/getNowTime'
import Navigation from '../components/navigation'

export default {
  name: 'cartoonDetail',
    components:{
      Navigation
  },
  data(){
      return{
        isActiveIndex:0,
        pageNum:1,
        cartoons:[],
        username:'',
        comments:'',
        cartoonId:null,
        isMsg:false,
        msgList:[],
        isWarnName:false,
        isWarnContent:false
      }
  },
  mounted(){
      this.cartoonId = getQueryString("cId");
      this.getView();
      this.getCartoonList();
  },
   computed:{
        massageList(){
            return this.msgList.map((e,i)=>{
                e.date = getNowTime(e.c_time)
                return e
            })
        }
    },
  methods:{ 
        goback(){
            this.$router.back(-1)
        },
        // 浏览
        getView(){
            api.view(JSON.stringify({
                type:'cartoon',
                c_id:this.cartoonId
            }))
        },
        cartoonPage(param){
            if(param === "front"){
                this.isActiveIndex = this.isActiveIndex -1
                this.cartoonId = this.cartoons[this.isActiveIndex].c_id
            }else{
                this.isActiveIndex = this.isActiveIndex +1
                this.cartoonId = this.cartoons[this.isActiveIndex].c_id
            }
        },
        // 获取漫画详情
        getCartoonList(){
            api.getCartoonList()
            .then((res) => {
                let resData = res.data
                if(resData.code === 200){
                    this.cartoons = resData.data
                    this.cartoons.forEach((e,i) => {
                        if(this.cartoonId == e.c_id){
                            this.isActiveIndex = i
                        }
                    });
                }
            })
        },
        goMsg(){
            this.isMsg = true
            this.username = ''
            this.comments = ''
            this.getMsgList()
        },
        getMsgList(){
            api.getMessageList(JSON.stringify({
                 c_id:this.cartoonId
            }))
            .then((res) => {
                let resData = res.data
                if(resData.code === 200){
                    this.msgList = resData.data
                }
            })
        },
        addMsg(){
            if(!this.username){
                this.isWarnName = true
                return false
            }
            this.isWarnName = false
            if(!this.comments){
                this.isWarnContent = true
                return false
            }
            this.isWarnContent = false
            api.addMessage(JSON.stringify({
                 c_id:this.cartoonId,
                 name:this.username,
                 content:this.comments
            }))
            .then((res) => {
                let resData = res.data
                if(resData.code === 200){
                    this.username = ''
                    this.comments = ''
                    this.getMsgList()
                }
            })
        }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
    .bg{
        background: url('../assets/images/news_bg.png') no-repeat;
        background-attachment: fixed;
        background-repeat: no-repeat;
        background-size: cover;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
    }
     .mb_cartoon_bg{
        background: url('../assets/images/mb_cartoon_bg.png') no-repeat;
        background-repeat: no-repeat;
        background-size: cover;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
        display: none;
    }
    .cartoonDetail{
        width: 100%;
        height: 100%;
        text-align: left;
    }
    .back_btn{
        width:232px;
        margin-top: 150px;
        margin-left: 80px;
        cursor: pointer;
          visibility: hidden;
    }
    .cartoon_title{
        // position: absolute;
        width:600px;
        margin-top: 300px;
        margin-left:1200px;
        // transform: translateX(-50%); 
    }
    .msg_btn{
        position: absolute;
        width: 300px;
        left: 2200px;
        top: 550px;
        cursor: pointer;
    }
    .cartoon_detail{
        width: 1500px;
        height: 1640px;
        position: relative;
        top: 150px;
        left: 50%;
        transform: translateX(-50%);
        padding: 40px;
        // background: url('../assets/images/cartoon_detail_border.png') no-repeat;
        // background-size: 100% 100%;
        .cartoon_box{
             width: 1400px;
            img{
                width: 100%;
            }
        }
        .cartoon_ul{
            width: 50000px;
            li{
            width: 1400px;
            float: left;
            margin-right: 80px;
            img{
                width: 100%;
            }
            }
        }
        
    }
    .cartoon_front,.cartoon_back{
        width: 160px;
        cursor: pointer;
        margin:100px 0;
        float: left;
    }
    .cartoon_back{
        margin-left: 100px;
        float: right;
    }
   
     .msg{
        background: url('../assets/images/msg_box.png') no-repeat;
        background-size: 100% 100%;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 2400px;
        height: 1400px;
        padding: 100px;
        color: #000;
        .close_msg{
            position: absolute;
            right: 0;
            top: -50px;
            width: 150px;
            cursor: pointer;
        }
        .msg_write{
            text-align: left;
            margin-left: 200px;
        }
        .name{
                font-size: 50px;
                font-weight: 700;
                input{
                    width: 800px;
                    height: 90px;
                    font-size: 50px;
                    background: #fff;
                    padding: 20px 30px;
                    vertical-align: bottom;
                    border-radius: 20px;
                    &::placeholder{
                        font-size:40px;
                    }
                }
                .warn{
                    font-size: 40px;
                    font-weight: 500; 
                    margin-left: 20px;
                    color: red;
                }
        }
        .comment{
            margin-top: 10px;
            .tag{
                font-size: 50px;
                font-weight: 700;
            }
            textarea{
                width: 1800px;
                height: 260px;
                line-height: 50px;
                font-size: 40px;
                background: #fff;
                padding: 20px;
                font-weight: 500;
                vertical-align: bottom;
                border-radius: 20px;
            }
        }
        .send_btn{
            width: 1800px;
            text-align: right;
            img{
                width: 200px;
                margin-right: 50px;
                cursor: pointer;
            }
            span{
                font-size: 40px;
                font-weight: 500; 
                margin-left: 20px;
                color: red;
                float: left;
            }
        }
        .msg_list{
            width: 1800px;
            height: 570px;
            margin: 0 auto;
            overflow: auto;
            ul{
                li{
                    width: 100%;
                    height: 260px;
                    border-radius: 20px;
                    background: #fff;
                    padding: 20px;
                    overflow:auto;
                    margin-bottom: 50px;
                    .info{
                        font-weight: 500;
                    }
                     .date{
                        float: right;
                    }
                }
            }
        }
    }
    .mask{
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background-color: rgba(0,0,0,0.7);
        z-index: 999;
    }
    
    
// 移动端
@media screen and (max-width: 750px) {
    .bg{
        display: none;
    }
    .mb_cartoon_bg{
        display: block;
    }
    .back_btn{
        width: 400px;
        margin-top: 400px;
    }
    .cartoon_title{
        width: 900px;
        margin-left: 900px;
        margin-top: 600px;
    }
     .msg_btn{
        width: 800px;
        left: 2500px;
        top: 850px;
    }
    .cartoon_detail{
        width: 3000px;
        height: 4200px;
        top: 150px;
        padding: 80px 80px;
        .cartoon_box{
            width: 2800px;
            .cartoon_ul{
                width: 50000px;
                li{
                    width: 2800px;
                }
            }
        }
    }
    .cartoon_front,.cartoon_back{
        width: 400px;
        margin: 200px 0;
    }
    .cartoon_back{
    }
    .msg{
        background: url('../assets/images/mb_msg_box.png') no-repeat;
        background-size: 100% 100%;
        width: 3200px;
        height: 5000px;
        padding: 200px 50px;
        .close_msg{
            top: -100px;
            width: 350px;
        }
        .msg_write{
            margin-left: 200px;
        }
        .name{
                font-size: 150px;
                font-weight: 600;
                input{
                    width: 1800px;
                    height: 280px;
                    font-size: 150px;
                    padding: 65px 30px;
                    border-radius: 50px;
                    &::placeholder{
                        font-size:120px;
                    }
                }
                .warn{
                    display: block;
                    font-size: 100px;
                    margin-left: 600px;
                }
        }
        .comment{
            .tag{
                font-size: 150px;
            }
            textarea{
                width: 2680px;
                height: 800px;
                line-height: 150px;
                font-size: 120px;
                padding: 50px;
                border-radius: 50px;
            }
        }
        .send_btn{
            width: 2680px;
            img{
                width: 450px;
                margin-right: 50px;
            }
            span{
                font-size: 100px;
            }
        }
        .msg_list{
            width: 2680px;
            height: 2700px;
            ul{
                li{
                    height: 700px;
                    border-radius: 50px;
                    margin-bottom: 100px;
                }
            }
        }
    }
}
</style>
